module.exports = "/static/assets/766b4a9cfc3b39807cc0b547476956c5.png";